import { isUserLanguageAvailableInCourse } from '@/utils/helpers';

import { User } from '@/client/users';

import { LanguagesEnum } from '@/api/enums';
import { Course } from '@/client/courses';

export const determineSelectedLanguage = (
  currentUser: User | null,
  course: Course | null,
): LanguagesEnum => {
  // Case 0: Course has only one language
  if (course?.courseLanguages?.length === 1) {
    return course.courseLanguages[0];
  }

  // Case 1: User has a specific content language and it's available in the course
  if (
    currentUser?.contentLanguage &&
    course &&
    isUserLanguageAvailableInCourse(
      course.courseLanguages,
      currentUser.contentLanguage,
    )
  ) {
    return currentUser.contentLanguage;
  }

  // Case 2: Use the user UI preferred language if it's available in the course
  if (
    currentUser?.language &&
    course &&
    isUserLanguageAvailableInCourse(
      course.courseLanguages,
      currentUser.language as LanguagesEnum,
    )
  ) {
    return currentUser.language as LanguagesEnum;
  }

  // Case 3: Fallback to course default language or English
  return course?.defaultLanguage || LanguagesEnum.EN;
};
